import styled from "styled-components";

export const PageRoot = styled.div`
    padding: 1rem 1.5rem 2rem;
`;

export const TableWrap = styled.div`
    margin-top: 1.5rem;
    overflow-x: auto;
`;

export const RiskBlock = styled.div`
    margin-top: 1.5rem;
    padding: 1rem;
    border-radius: 12px;
    background: rgba(204, 33, 79, 0.06);
`;

export const AlternativesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 12px;
`;

export const AlternativeRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #e5e5e5;
`;

export const Message = styled.p`
    margin-top: 1rem;
    font-size: 15px;
`;

export const ErrorText = styled.p`
    margin-top: 1rem;
    font-size: 15px;
    color: #a4262c;
`;

export const InfoText = styled.p`
    margin-top: 1rem;
    font-size: 15px;
    color: #0b6a0b;
`;

export const ActionsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 16px;
    flex-wrap: wrap;
`;
